import { FC } from "react"

interface IClipAvatar {}

export const ClipAvatar: FC<IClipAvatar> = () => {
  return (
    <svg
      width="77"
      height="73"
      viewBox="0 0 77 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.48387 72.734L0 63.1277V0H76.3226V63.1277L66.8387 72.734H9.48387Z" />
      <clipPath
        id="clipPath_avatar"
        clipPathUnits="objectBoundingBox"
        transform="scale(0.01298701298, 0.01369863013)"
      >
        <path d="M9.48387 72.734L0 63.1277V0H76.3226V63.1277L66.8387 72.734H9.48387Z" />
      </clipPath>
    </svg>
  )
}
